import { useCurrentUser } from '../domains/login/useLoginStore';

const useHasProfile = (searchProfileName: string): boolean => {
  const { profiles } = useCurrentUser();

  return profiles.some(
    (profileName) =>
      profileName.toLowerCase() === searchProfileName.toLowerCase(),
  );
};

export default useHasProfile;
